/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Dashboard from "./Dashboard";
import BackSections from "../Giftcards/BackSections";
const MyProfileContent = () => {
  const [showError, setShowError] = useState(false);
  const isLogin = sessionStorage.getItem("login");
  const V3Data = useSelector((state) => state.cardDataSliceReducer);

  const activeTab = useSelector(
    (state) => state.activeTabSliceReducer.activeTab
  );
  useEffect(() => {
    !isLogin && setShowError(true);
  }, []);
  const handleLogin = () => {
    window.open(V3Data?.SignInUrl, "_self");
  };
  return (
    <>
      {showError ? (
        handleLogin()
      ) : (

        <section className="header1 bg light_bg_white">
          <BackSections />
          <div className="myprofile_section">
            <div className="container">
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-md-8">

                  <div className="tab-content" id="v-pills-tabContent">

                    <Dashboard activeTab={activeTab} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default MyProfileContent;
